export function getRandomHexColor() {
    // Generates a random hexadecimal color
    return '#' + Math.floor(Math.random() * 16777215).toString(16);
}
  
export function generateRandomHexColors(count) {
    // Generates an array of random hexadecimal colors
    const colors = [];
    for (let i = 0; i < count; i++) {
      colors.push(getRandomHexColor());
    }
    return colors;
}